import React, { Fragment, useEffect, useRef, useState } from 'react';
import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import { AnimChangeChildren } from 'libs/growth-platform-brand-system-v2/src/utils/AnimChangeChildren';

export default function Highlighted({
  label,
  isFirstPayroll,
  roundedType = 'rounded-18',
}: {
  label?: string;
  isFirstPayroll: boolean;
  roundedType?: 'rounded-18' | 'rounded-12';
}) {
  const [width, setWidth] = useState(0);
  const labelRef = useRef<HTMLDivElement>(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const isMounted = useRef(false);

  const handleAnimationEnd = () => {
    setIsAnimating(false);
  };

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    setIsAnimating(true);
    if (labelRef.current) {
      const computedWidth = getComputedStyle(labelRef.current).width;
      setWidth(parseFloat(computedWidth));
    }
  }, [label]);

  return (
    <div
      className={classNames(
        'highlightOffer',
        'absolute -inset-[1px] border-[4px] bg-clip-border',
        'transition-all duration-300 ease-in-out',
        isFirstPayroll
          ? 'border-[#32CEBA] shadow-glow-cyan'
          : 'border-[#288BFB] shadow-glow-blue',
        roundedType === 'rounded-18' && 'rounded-[18px]',
        roundedType === 'rounded-12' && 'rounded-[12px]',
      )}
    >
      <div
        className={classNames(
          'absolute -inset-[4px]',
          'bg-gradianTransparent p-[4px]',
          roundedType === 'rounded-18' && 'rounded-[17px]',
          roundedType === 'rounded-12' && 'rounded-[11px]',
        )}
      >
        <div
          className={classNames(
            'h-full',
            roundedType === 'rounded-18' && 'rounded-[15px]',
            roundedType === 'rounded-12' && 'rounded-[11px]',
            isFirstPayroll
              ? 'highlightOffer_bgContent_green'
              : 'highlightOffer_bgContent_blue',
          )}
        />
      </div>
      {isAnimating && label && (
        <div
          ref={labelRef}
          aria-hidden="true"
          className="invisible absolute whitespace-nowrap px-[12px] py-[4px]"
        >
          {label}
        </div>
      )}
      {label && (
        <div
          className={classNames(
            isFirstPayroll ? 'bg-[#32CEBA]' : 'bg-[#288BFB]',
            'absolute -right-[1px] -top-[1px]',
            'text-white',
            'transition-all duration-300 ease-in-out',
            'px-[12px] py-[4px]',
            'rounded-bl-[8px] rounded-tr-[8px]',
            'whitespace-nowrap',
            'overflow-hidden',
          )}
          style={{ width: width ? `${width}px` : 'fit' }}
          onAnimationEnd={handleAnimationEnd}
        >
          <AnimChangeChildren animateTransition={{ delay: 0.3 }}>
            <Fragment key={label}>{label}</Fragment>
          </AnimChangeChildren>
        </div>
      )}
    </div>
  );
}
